<!--  -->
<template>
  <Card class="basic_card"> 
    <div slot="title" class="box">
      <span class="card_title">{{title}}</span>
      <Tooltip v-if="tip" :content="tip" placement="bottom-start" class="tootip" max-width="200">
        <Icon type="ios-help-circle-outline" size="16" color="#333" class="card-title-icon"/>
      </Tooltip>
      <slot name="tip"></slot>
    </div>
    <div class="box" slot="extra">
      <slot name="right"></slot>
    </div>
    <div class="box">
      <div v-if="isShowZW" :style="{height:height}"></div>
      <img
        v-if="!isShowZW && isShowPic && content_obj.headpicture"
        :src="content_obj.headpicture"
        class="headpicture"
      >
      <img
        v-if="!isShowZW && isShowPic && !content_obj.headpicture"
        src="../../../assets/images/default.png"
        class="headpicture"
      >
      <div class="right box_v">
        <div v-if="content_obj.title">{{content_obj.title}}</div>
        <div
          v-for="(item,index) in content_obj.content_arr"
          :key="index"
          class="content box"
          :class="{editclass: isEditMode && item.isEditable}"
        >
          <div class="box">{{item.name+'：'}}</div>
          <div class="box_f1 box_v" v-if="isEditMode && item.isEditable">
            <Input
              type="textarea"
              v-model="item.content"
              class="box_f1"
              @on-change="textboxChange($event,index)"
              :autosize="true"
              :rows="rownumber"
              :maxlength="item.maxlength"
            />
            <div v-if="index==editIndex && isMaxLength">*最多可输入{{item.maxlength}}个字</div>
          </div>
          <div v-else class="box_f1">{{item.content}}</div>
        </div>
        <upload-img
          v-if="imgNumber"
          :imgArr="imgArr"
          :imgNumber="imgNumber"
          style="margin-top:20px"
          @delPic="delBasicPic"
          @saveImg="saveBasicImg"
        >
          <div class="iconfont icon-shangchuan1 img_add"></div>
        </upload-img>
      </div>
    </div>
  </Card>
</template>

<script>
import uploadImg from "../../../components/uploadImg";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
var vm = this;
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    uploadImg
  },
  //接收父组件的值
  props: {
    title: String, //卡片标题
    content_obj: Object, //内容列表
    width: String, //卡片宽度
    height: String, //卡片高度
    tip: String, //卡片提示
    isEditMode: Boolean, //是否为编辑模式
    maxlength: Number,
    rownumber: Number,
    imgArr: Array,
    imgNumber: {
      type: Number,
      default: 0
    }
  },
  data() {
    //这里存放数据
    return {
      editIndex: 0,
      isMaxLength: false, //是否达到最大长度
      isShowPic: false
    };
  },
  //监听属性 类似于data概念
  computed: {
    isShowZW() {
      return !this.content_obj.content_arr.length;
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    textboxChange(e, index) {
      this.editIndex = index;
      if (
        e.target.textLength == this.content_obj.content_arr[index].maxlength
      ) {
        this.isMaxLength = true;
      } else {
        this.isMaxLength = false;
      }
    },
    delBasicPic (data) {
      this.$post(this.urlobj.getSysPic(),{
        id:data.id
      }).then(resp=>{
                  this.$emit('delImgArr',data.index)
              }).catch(error=>{
                  console.log(error)
              })
    },
    saveBasicImg (data) {
          this.$post(this.urlobj.getSysPic(),{
            picId:data.id
          }).then(res=>{
              let img_obj={
                   path : data.path,
                   id : res.rows[0].id
              }
              this.imgArr.push(img_obj)
          })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.content_obj.hasOwnProperty("headpicture")) {
      this.isShowPic = true;
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang='less'>
//@import url(); 引入公共css类
.basic-card {
  margin: 30px 0 0 30px;
  height: auto;
}
.editclass {
  margin-top: 10px;
}
.content {
  color: #999;
  align-items: flex-start;
}
.header-button {
  margin-top: -8px;
  margin-left: 20px;
}
.card_title {
  margin-right: 10px;
}
.tootip {
  white-space: normal;
}
.headpicture {
  width: 95px;
  height: 95px;
  margin: 0;
  border-radius: 50%;

  margin-right: 20px;
}
.right {
  width: 100%;
}
.img_add {
  color: #bbbbbb;
  border: 1px solid #bbb;
  text-align: center;
  line-height: 50px;
  height: 50px;
  width: 100px;
  position: relative;
}
/deep/ .imgbox {
  margin-bottom: 0;
}
</style>
